import LoadingPlaceholder from "@/components/ui/loading-placeholder/LoadingPlaceholder";
import { ArtifactCard } from "@/components/artifacts/ArtifactCard";
import { useClientArtifacts } from "@/services/api/agentic-v2/queries/useClientArtifacts";

export interface ClientArtifactsSectionProps {
  faClientId: string;
}

/** Artefacts tab — shared cached fetch with Plans tab. */
export function ClientArtifactsSection({ faClientId }: ClientArtifactsSectionProps) {
  const { artifacts, loading, error } = useClientArtifacts({ faClientId });

  if (loading) {
    return <LoadingPlaceholder height="200px" />;
  }
  if (error) {
    return (
      <div className="rounded-xl border border-red-500/20 bg-red-500/5 px-4 py-3 text-sm text-red-700 dark:text-red-200">
        {error.message}
      </div>
    );
  }
  if (artifacts.length === 0) {
    return (
      <div className="rounded-xl border border-slate-950/10 bg-slate-950/[3%] px-6 py-14 text-center text-sm text-slate-500 dark:border-slate-800/80 dark:bg-slate-900/20 dark:text-slate-400">
        No artefacts yet for this client.
      </div>
    );
  }
  return (
    <div className="space-y-2">
      {artifacts.map((artifact) => (
        <ArtifactCard key={artifact._id} artifact={artifact} />
      ))}
    </div>
  );
}
